import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api.js';
import { PLACEHOLDER_EDITIONS } from '../../lib/welcomeEditions.js';
import WelcomeEditionCard from '../marketing/WelcomeEditionCard.jsx';

export default function HomeLatestPosts() {
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await api.get('/archive/list?view=editions&limit=8');
        const fetched = data?.rows?.length ? data.rows : PLACEHOLDER_EDITIONS;
        if (!cancelled) {
          setRows(fetched.slice(0, 8));
          setStatus('ready');
        }
      } catch {
        if (!cancelled) {
          setRows(PLACEHOLDER_EDITIONS.slice(0, 8));
          setStatus('ready');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section
      className="max-w-page mx-auto px-4 sm:px-6 py-10 sm:py-14 border-t border-[#D4D4D4] pb-16"
      aria-labelledby="home-latest-heading"
    >
      <h2
        id="home-latest-heading"
        className="font-sans text-[clamp(1.125rem,2.5vw,1.5rem)] font-bold text-hxd-orange text-center m-0 mb-8"
      >
        Latest posts
      </h2>

      {status === 'loading' && (
        <p className="text-[13px] text-hxd-muted italic text-center m-0">Loading editions…</p>
      )}

      {status === 'ready' && rows && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {rows.map((row) => (
            <Link
              key={row.isoDate}
              to={`/archive/${row.isoDate}`}
              className="block h-[340px] hover:opacity-95 transition-opacity no-underline"
            >
              <WelcomeEditionCard row={row} linked />
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
